import { render, staticRenderFns } from "./main-link-card.vue?vue&type=template&id=31b0086c&scoped=true"
import script from "./main-link-card.vue?vue&type=script&lang=js"
export * from "./main-link-card.vue?vue&type=script&lang=js"
import style0 from "./main-link-card.vue?vue&type=style&index=0&id=31b0086c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b0086c",
  null
  
)

export default component.exports